module.exports = __webpack_public_path__ + "img/wbz.39580675.jpg";